<script lang="ts">
    import { onMount } from "svelte";
	import { Router, Route, navigate } from "svelte-navigator";
	import { SvelteToast } from '@zerodevx/svelte-toast'
	import {api, config, solidwindInstance, oidcToken, swClient, modal} from "./stores";
    import { login, checkToken } from "./oidc";
	import type { OIDC } from "./oidc";

	import Home from "./Home.svelte";
	import Login from "./Login.svelte";
	import Admin from "./admin/Admin.svelte";
    import Loading from "./Loading.svelte";
	import CatalogNotFound from "./CatalogNotFound.svelte";
	import PrivateRoute from "./PrivateRoute.svelte";

	import Modal from 'svelte-simple-modal';

	export let configPath: string;
	let uri = "";
	let oidc: OIDC;

	// Option for svelte toast feature
	const options = {
		initial: 1,           // initial progress bar value
		next: 0,              // next progress value
		pausable: true      // pause progress bar tween on mouse hover
	}

    onMount(async () => {
		(await fetch(configPath)).json().then(conf => {
			$config.setConfig(conf);
			$api.setUri(conf.API.uri);
			$api.setUploadUri(conf.API.upload_uri);
			$solidwindInstance = conf.solidwindInstance;
			$swClient.uri = conf.solidwindInstance.uri;
			oidc = conf.oidc;
			uri = conf.API.uri;

			let t = localStorage.getItem("onecatalog-admin-token");
			if (t) {
				oidcToken.set(t);
			} else {
				let t = checkToken(window.location.hash);
				if (t) {
					oidcToken.set(t);
                	navigate("/admin", { replace: true });
				}
			}
		})
		oidcToken.subscribe((value) => {
			if (value) {
				$swClient.token = value;
				localStorage.setItem("onecatalog-admin-token", value);
			}
		});
	});

    function handleLogin() {
        oidcToken.set(undefined);
        login(window.location, oidc);
    }
</script>

<SvelteToast {options} />

{#if uri !== ""}
	<Router primary={false}>
		<Modal show={$modal} closeButton="{true}">
			<Route path="/" component="{CatalogNotFound}"></Route>
			<Route path="/login">
				<Login on:login={handleLogin} />
			</Route>
			<PrivateRoute path="admin/*" let:location>
				<Admin/>
			</PrivateRoute>
			<Route path="/catalog/:catalog/:shop/*" let:params let:location>
				<Home catalog={params.catalog} shop={params.shop}></Home>
			</Route>
		</Modal>
	</Router>
{:else}
	<Loading force="{true}"/>
{/if}